import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Column } from 'hedron';
import { Bind } from 'lodash-decorators';

import { ArticleSlider as ArticleSliderModel } from 'models';

import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import Container from 'blocks/Container/Container';
import Carousel from 'blocks/Carousel/Carousel';
import SliderButton from 'blocks/SliderButtons/SliderButton';
import carouselSettings from './carouselSettings';
import Header from './Header';
import SliderWrapper from './SliderWrapper';
import ArticleSlide from './ArticleSlide';
import LeftButtonWrapper from './LeftButtonWrapper';
import RightButtonWrapper from './RightButtonWrapper';

export default class ArticleSlider extends Component {
  @Bind
  slickNext() {
    if (this.sliderRef) {
      this.sliderRef.slickNext();
    }
  }

  @Bind
  slickPrev() {
    if (this.sliderRef) {
      this.sliderRef.slickPrev();
    }
  }

  render() {
    const {
      data: { header, articleSlides, htmlModifiers },
    } = this.props;

    return (
      <HTMLModifiableBackground htmlModifiers={htmlModifiers}>
        <Container>
          <SliderWrapper>
            <Column lg={12}>
              <Header>
                {header}
              </Header>
              <Carousel
                settings={carouselSettings}
                innerRef={(ref) => { this.sliderRef = ref; }}
              >
                {articleSlides.map((slide, index) => (
                  <ArticleSlide
                    article={slide}
                    key={slide.system.id}
                    index={index}
                  />
                ))}
              </Carousel>
            </Column>
            <LeftButtonWrapper>
              <SliderButton
                animateArrow
                onClick={this.slickPrev}
              />
            </LeftButtonWrapper>
            <RightButtonWrapper>
              <SliderButton
                animateArrow
                right
                onClick={this.slickNext}
              />
            </RightButtonWrapper>
          </SliderWrapper>
        </Container>
      </HTMLModifiableBackground>
    );
  }
}

ArticleSlider.propTypes = {
  data: PropTypes.instanceOf(ArticleSliderModel).isRequired,
};



// WEBPACK FOOTER //
// ./src/kentico-blocks/ArticleSlider/index.jsx